import QRCode from 'qrcode'
import React from 'react'

import './PalletPrint.css'
import printCssContent from './PalletPrint.css?inline'
import PrintContent from './PrintContent'

import PrintDialog from '@/components/common/PrintDialog'
import { PalletCargoMark } from '@/services/InboundV2Service'


export interface PalletPrintData {
  customerNumber?: string
  houseBlNumber: string
  devanDate: string
  palletCode: string
  total: number
  cargoMarks: PalletCargoMark[]
  notes?: string
  printUser?: string
}

interface PalletPrintProps {
  data: PalletPrintData
  visible: boolean
  onClose: () => void
}

const PalletPrint: React.FC<PalletPrintProps> = ({
  data,
  visible,
  onClose
}) => {
  const [qrCodeUrl, setQrCodeUrl] = React.useState<string>('')

  React.useEffect(() => {
    if (data.palletCode) {
      QRCode.toDataURL(data.palletCode, {
        width: 200,
        margin: 1,
        errorCorrectionLevel: 'M'
      })
        .then((url) => {
          setQrCodeUrl(url)
        })
        .catch((err) => {
          console.error('生成二维码失败:', err)
        })
    }
  }, [data.palletCode])

  if (!visible) return null

  return (
    <>
      <PrintDialog
        pageWidth={104}
        pageHeight={104}
        visible={visible}
        isMultiPage={false}
        pageCssContent={printCssContent}
        onCancel={() => onClose()}
      >
        <PrintContent data={data} qrCodeUrl={qrCodeUrl} />
      </PrintDialog>
    </>
  )
}

export default PalletPrint
